import { formatDollarAmount } from '@/utils/number';
import type { PlatformCompany } from '../../../../types';

interface ExportBlockProps {
  show: boolean;
  company: Pick<PlatformCompany, 'allTotalTransactions' | 'allValueOfGoodsUSDDouble' | 'allLastTransactionDate'>;
}

const EXPORT_LABELS = ['Exports Count', 'Exports Value', 'Last Export'];

export function ExportBlock({ show, company }: ExportBlockProps) {
  const { allTotalTransactions, allValueOfGoodsUSDDouble, allLastTransactionDate } = company;
  const items = [
    allTotalTransactions,
    allValueOfGoodsUSDDouble ? formatDollarAmount(Number(allValueOfGoodsUSDDouble)) : '-',
    allLastTransactionDate,
  ];

  if (!show) return null;

  return (
    <>
      {/* 出口统计三列 */}
      <div className="h-[46px] mt-4 flex flex-row items-center gap-3 w-full">
        {EXPORT_LABELS.map((label, i) => (
          <div key={label} className="flex flex-col gap-1 flex-1 min-w-0">
            <span className="text-sm font-medium text-[#262626] truncate">{items[i] ?? '-'}</span>
            <span className="text-sm text-[#8C8C8C]">{label}</span>
          </div>
        ))}
      </div>
    </>
  );
}
